import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AppHeader from './AppHeader';

type Props = { children: ReactNode; roles?: string[] };

export default function ProtectedRoute({ children, roles }: Props) {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return setAllowed(false);

        const res = await fetch('/api/auth/me', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) return setAllowed(false);
        const data = await res.json();
        if (!roles || roles.length === 0) return setAllowed(true);
        setAllowed(roles.includes(data.user.role));
      } catch {
        setAllowed(false);
      }
    })();
  }, [roles?.join(',')]);

  // Don't render anything while checking authentication (prevents flash)
  if (allowed === null) return null;

  return allowed ? (
    <div className="min-h-screen">
      <AppHeader />
      {children}
    </div>
  ) : <Navigate to="/" replace />;
}
